import { useState, useEffect } from 'react';



function useHyphenCheck(string) {
  const [hasHyphen, setHasHyphen] = useState(false);

  useEffect(() => {
    setHasHyphen(string?.includes('-'));
  }, [string]);

  return hasHyphen;
}

export default useHyphenCheck;